import { useQuery } from "react-query";
import { TrainingResponse } from "../../../../models/Training";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import ApiClient from "../../../apiClient";

export const allTrainingKey = "all-training-key";

export async function allTraining(): Promise<TrainingResponse[]> {
  const res = await ApiClient.get(`/AllTraining`);
  return res.data;
}

export default function useFetchAllTraining() {
  return useQuery([allTrainingKey], queryWrapper(allTraining));
}
